import { render, staticRenderFns } from "./ModalAvailableForRedemption.vue?vue&type=template&id=ff3dba78&scoped=true"
import script from "./ModalAvailableForRedemption.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalAvailableForRedemption.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalAvailableForRedemption.vue?vue&type=style&index=0&id=ff3dba78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff3dba78",
  null
  
)

export default component.exports